import React from 'react';
import { Box, Container, Grid, Paper, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { motion } from 'framer-motion';
import { FEATURES, FEATURES_HEADING } from '../demoContent';
import IconTile from './IconTile';
import SectionHeading from './SectionHeading';

/** The product's strongest capabilities — each one maps to a shipped feature in this codebase. */
export default function FeatureGrid() {
  const theme = useTheme();

  return (
    <Box
      component="section"
      sx={{ bgcolor: alpha(theme.palette.primary.main, 0.045), py: { xs: 8, md: 11 } }}
    >
      <Container maxWidth="lg">
        <SectionHeading
          overline={FEATURES_HEADING.overline}
          heading={FEATURES_HEADING.heading}
          sub={FEATURES_HEADING.sub}
        />

        <Grid container spacing={3}>
          {FEATURES.map((feature, index) => (
            <Grid item xs={12} sm={6} md={4} key={feature.title}>
              <motion.div
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-60px' }}
                transition={{ duration: 0.5, delay: (index % 3) * 0.07, ease: 'easeOut' }}
                style={{ height: '100%' }}
              >
                <Paper
                  elevation={0}
                  sx={{
                    height: '100%',
                    p: 3.5,
                    borderRadius: 2.5,
                    border: '1px solid',
                    borderColor: 'divider',
                    boxShadow: 'none',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: '0 12px 28px rgba(26, 36, 112, 0.12)',
                    },
                  }}
                >
                  <IconTile Icon={feature.Icon} accent={feature.accent} />
                  <Typography variant="h6" sx={{ fontWeight: 600, mt: 2.5 }}>
                    {feature.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1, lineHeight: 1.65 }}>
                    {feature.description}
                  </Typography>
                </Paper>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
